import firestore from 'libs/firebase/shims/firestore'

export const firestoreRemoteStore = firestore()
